import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type {
  AdminHomeDashboardFilterParams,
  AdminHomeDashboardStatsData,
} from "./Types";

type AdminHomeDashboardState = {
  data: AdminHomeDashboardStatsData | null;
  filters: AdminHomeDashboardFilterParams;
  status: {
    loading: boolean;
    error: string | null;
  };
};

const initialState: AdminHomeDashboardState = {
  data: null,
  filters: {},
  status: {
    loading: false,
    error: null,
  },
};

const adminHomeDashboardSlice = createSlice({
  name: "admin_home_dashboard",
  initialState,
  reducers: {
    setAdminHomeDashboardLoading: (state, action: PayloadAction<boolean>) => {
      state.status.loading = action.payload;
    },
    setAdminHomeDashboardError: (state, action: PayloadAction<string | null>) => {
      state.status.error = action.payload;
    },
    setAdminHomeDashboardData: (
      state,
      action: PayloadAction<{
        data: AdminHomeDashboardStatsData;
        filters: AdminHomeDashboardFilterParams;
      }>
    ) => {
      state.data = action.payload.data;
      state.filters = action.payload.filters;
      state.status.error = null;
    },
    clearAdminHomeDashboard: (state) => {
      state.data = null;
      state.filters = {};
      state.status.error = null;
    },
  },
});

export const adminHomeDashboardSliceAction =
  adminHomeDashboardSlice.actions;
export const adminHomeDashboardSliceReducer =
  adminHomeDashboardSlice.reducer;
